import React from "react";
import { Box, Button, Chip, Stack, Typography } from '@curves/ui-base';

import { OverflowMenu } from "@Local/Components";
import { DateTimeDisplay } from "@Local/Components/RowLabel";
import { formatCurrencyFn, parseCardExpiry, isEmpty } from "@Util/utils";
import { matchOrderStatusColors } from "@Local/CyclePurchase/staticData";
import MemberAvatar from "@Local/Components/InfoCard/MemberAvatar";
// 循環訂單總覽列表
export const getCyclePurchaseOverviewRowLabel = (pushToCyclePurchaseDetail, overviewData, dialogRef, refresh) => {
	return [
		{
			cellKey: "cycleOrderNo",
			headerLabel: "循環訂單編號",
			width: "12",
			align: "center",
			formatCell: (cellValue, rowData) => {
				const handleClick = () => {
					if (rowData?.cycleOrderID) {
						pushToCyclePurchaseDetail(rowData.cycleOrderID);
					}
				};
				return (
					<Stack direction={"column"}>
						<Button variant="text" color="primary" onClick={handleClick}>
							{rowData?.cycleOrderNo || "-"}
						</Button>
						<Chip label={rowData?.cycleOrderTypeText} color={matchOrderStatusColors(rowData?.statusColor)} title={"訂單狀態"} />
					</Stack>
				);
			},
		},
		{
			cellKey: "memberName",
			headerLabel: "會員",
			formatCell: (cellValue, rowData) => {
				return (
					<Stack alignItems="center" spacing={2}>
						<Box className="cycle-purchase-overview-img-label">
							<MemberAvatar src={rowData?.memberImg || "-"} alt="avatar" />
						</Box>
						<Stack direction={"column"}>
							<Typography>{rowData?.memberName || "-"}</Typography>
							<Typography className="font-color-3">{rowData?.nickName || "-"}</Typography>
							<Typography className="font-color-3">{rowData?.memberNo || "-"}</Typography>
						</Stack>
					</Stack>
				);
			},
		},
		{
			cellKey: "items",
			headerLabel: "訂單內容",
			formatCell: (cellValue, rowData) => {
				return (
					<Stack direction={"column"} spacing={1}>
						<Typography className="font-color-3">出貨週期：{rowData?.shippingDayText || "-"}</Typography>
						{rowData?.items?.map((item, index) => (
							<Typography key={index}>
								{item?.productName || "-"} x {item?.quantity || "-"}
							</Typography>
						))}
					</Stack>
				);
			},
		},
		{
			cellKey: "saleAmount",
			headerLabel: "訂單金額",
			align: "center",
			formatCell: (cellValue, rowData) => {
				return <Typography>{formatCurrencyFn(rowData?.saleAmount || "-")}</Typography>;
			},
		},
		{
			cellKey: "cardExpiryDate",
			headerLabel: "信用卡效期",
			align: "center",
			formatCell: (cellValue, rowData) => {
				return <Typography>{parseCardExpiry(rowData?.cardExpiryDate || "-")}</Typography>;
			},
		},
		{
			cellKey: "updatedDate",
			headerLabel: "更新日期",
			width: "12",
			formatCell: (cellValue, rowData) => {
				if (rowData?.updatedDate) {
					return <DateTimeDisplay date={rowData.updatedDate} />;
				}
				return (
					<Stack direction={"column"}>
						<Typography>{rowData?.updatedDate || "-"}</Typography>
						<Typography>{rowData?.updatedTime || "-"}</Typography>
					</Stack>
				);
			},
		},
		{
			cellKey: "employeeName",
			headerLabel: "擔當",
			align: "center",
			formatCell: (cellValue, rowData) => {
				return <Typography>{rowData?.employeeName || "-"}</Typography>;
			},
		},
		{
			cellKey: "cycleOrderID",
			headerLabel: "",
			align: "right",
			isIcon: true,
			formatCell: (cellValue, rowData) => {
				const menuData = [
					{
						text: "主單明細",
						onClick: () => {
							if (rowData?.cycleOrderID) {
								pushToCyclePurchaseDetail(rowData.cycleOrderID);
							}
						},
					},
					{
						text: "循環訂單收費明細",
						onClick: () => {
							if (rowData?.cycleOrderID && dialogRef?.current) {
								dialogRef.current.openDetailsDialog(
									{
										cycleOrderID: rowData?.cycleOrderID,
										memberID: rowData?.memberID,
										clubName: rowData?.clubName,
										memberName: rowData?.memberName,
										cellPhone: rowData?.cellPhone,
										memberNo: rowData?.memberNo,
									},
									refresh
								);
							}
						},
					},
				];
				return <OverflowMenu menuData={menuData} enabled={!isEmpty(menuData)} />;
			},
		},
	];
};
